module.exports = __webpack_public_path__ + "img/cancelChange.cead76ac.svg";